import React from 'react';
import 'react-day-picker/dist/style.css';
import FunctionalTableComponent from '../table/FunctionalTableComponent';


const FunctionalTableField = ({ field, data, onDataUpdate }) => {

  if (data) {
    data.forEach(item => {
      if (!item.id) {
        item.id = Math.floor(Math.random() * 101010);
      }
    });
  }

  return (
    <FunctionalTableComponent
      key={field.name}
      shadow={false}
      className={field.className}
      title={field.title}
      columns={field.functionalTableConfig.columns}
      header={true}
      setLoader={() => {
      }}
      removable={true}
      creationFields={field.functionalTableConfig.fields}
      deleteModalTitle={field.functionalTableConfig.deleteModalTitle}
      creationTitle={field.functionalTableConfig.creationTitle}
      modalSize={'lg'}
      deleteModalDescription={field.functionalTableConfig.deleteModalDescription}
      editable={field.functionalTableConfig.editable !== false}
      width={12}
      noCard={field.noCard}
      onDataUpdate={onDataUpdate}
      initialData={data}
    />
  );
};

export default FunctionalTableField;
